import { TwinDictionary } from '../../../utils/globals/dictionary'
import { prepareForSearch, stringMatchWithSearch } from '../../../utils/globals/search'

export const filterCustomSelectItemsBlocked = (searchValue: string, items: TwinDictionary, fieldName='text') => {
    const filteredItems: TwinDictionary = {}
    for (const key in items) {
        const item = items[key]
        if (stringMatchWithSearch(searchValue, String(item[fieldName]))) {
            filteredItems[key]= item
        }
    }  
    return filteredItems
}

export const sortItemsBlocked = (items: TwinDictionary, fieldName = 'name') => {
    const result: any[] = []
    const itemsBlocked: any[] = []
    for (const key in items) {
        const item = items[key]
        const myItem = { ...item, value: key, text: item?.[fieldName] }
        if(item.is_blocked){
            itemsBlocked.push(myItem)
        }else{
            result.push(myItem)
        }
    }
    result.sort((a, b) => {
        if (typeof a.text === 'string' && typeof b.text === 'string') {
            return prepareForSearch(a.text) > prepareForSearch(b.text) ? 1 : -1
        }
        return a.text > b.text ? 1 : -1
    })
    itemsBlocked.sort((a, b) => {
        if (typeof a.text === 'string' && typeof b.text === 'string') {
            return prepareForSearch(a.text) > prepareForSearch(b.text) ? 1 : -1
        }
        return a.text > b.text ? 1 : -1
    })
    return [...result, ...itemsBlocked]
}